import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import Auth from '../views/auth/Auth.vue'

const routes = [
  {
    path: PATHS.AUTH,
    name: 'Auth',
    component: Auth,
  },
  {
    path: PATHS.HOME,
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: PATHS.ADMIN,
    name: 'Admin',
    component: () =>
      import(/* webpackChunkName: "reports" */ '../views/admin/Admin.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: PATHS.ADMIN_USERS,
        name: 'AdministrationUsers',
        component: () =>
          import(
            /* webpackChunkName: "admin" */ '../views/admin/users/Users.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: PATHS.ADMIN_QUERIES,
        name: 'AdministrationQueries',
        component: () =>
          import(
            /* webpackChunkName: "admin" */ '../views/admin/queries/Queries.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: PATHS.DOCUMENTS,
    name: 'Documents',
    component: () =>
      import(
        /* webpackChunkName: "documents" */ '../views/documents/Documents.vue'
      ),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: 'ContractsList',
        path: PATHS.DOCUMENTS_CONTRACTS,
        component: () =>
          import(
            /* webpackChunkName: "contracts" */ '../views/documents/contracts/ContractsList.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'ContractDetails',
        path: PATHS.DOCUMENTS_CONTRACTS_DETAILS,
        component: () =>
          import(
            /* webpackChunkName: "contracts" */ '../views/documents/contracts/ContractDetails.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'MovimentsList',
        path: PATHS.DOCUMENTS_MOVIMENTS,
        component: () =>
          import(
            /* webpackChunkName: "moviments" */ '../views/documents/moviments/MovimentsList.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'MovimentDetails',
        path: PATHS.DOCUMENTS_MOVIMENTS_DETAILS,
        component: () =>
          import(
            /* webpackChunkName: "moviments" */ '../views/documents/moviments/MovimentDetails.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'MeasureEdit',
        path: PATHS.DOCUMENTS_MEASURES_EDIT,
        component: () =>
          import(
            /* webpackChunkName: "measures" */ '../views/documents/measures/MeasureEdit.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'SuppliersList',
        path: PATHS.DOCUMENTS_SUPPLIERS,
        component: () =>
          import(
            /* webpackChunkName: "suppliers" */ '../views/documents/suppliers/SuppliersList.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'SupplierDetails',
        path: PATHS.DOCUMENTS_SUPPLIERS_DETAILS,
        component: () =>
          import(
            /* webpackChunkName: "suppliers" */ '../views/documents/suppliers/SupplierDetails.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: PATHS.REPORTS,
    name: 'Reports',
    component: () =>
      import(/* webpackChunkName: "reports" */ '../views/reports/Reports.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: 'MyMeasures',
        path: PATHS.REPORTS_MY_MEASURES,
        component: () =>
          import(
            /* webpackChunkName: "reports" */ '../views/reports/MyMeasures.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'ManagerPendences',
        path: PATHS.REPORTS_MANAGER_PENDENCES,
        component: () =>
          import(
            /* webpackChunkName: "reports" */ '../views/reports/ManagerPendences.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'FinancialPendences',
        path: PATHS.REPORTS_FINANCIAL_PENDENCES,
        component: () =>
          import(
            /* webpackChunkName: "reports" */ '../views/reports/FinancialPendences.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'MeasuresInvoiced',
        path: PATHS.REPORTS_MEASURES_INVOICED,
        component: () =>
          import(
            /* webpackChunkName: "reports" */ '../views/reports/MeasuresInvoiced.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  store.dispatch('setPreviousRouter', from.name)

  const { isLoggedInSenarRC } = store.getters

  if (isLoggedInSenarRC && to.name === 'Auth') {
    return { name: 'Home' }
  }
  if (to.meta.requiresAuth) {
    if (!isLoggedInSenarRC && !localStorage.getItem('tokenSenarRC')) {
      return { name: 'Auth' }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedInSenarRC && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.AUTH)
  }
})

export default router
